import { useContext, useEffect, useMemo } from "react";
import olVectorSource from "ol/source/Vector";
import olFeature from "ol/Feature";
import { Style, Stroke } from "ol/style";
import { containsExtent } from "ol/extent";
import type { RouteLine } from "../../../../../types/RouteLine/RouteLine";
import { Vector } from "../../../../reactOL/layers/Vector";
import { useViewContext } from "../../../../../context/View/ViewContext";
import MapContext from "../../../../reactOL/map/MapContext";
import { useLocation } from "react-router-dom";
import { MapView } from "../../../../../constant/VectorTileLayerType";

interface SelectedRouteLineLayerProps {
  selectedRouteLine: RouteLine | null | undefined;
}

const selectedRouteLineStyle = new Style({
  stroke: new Stroke({
    color: "orange",
    width: 6,
    lineCap: "round",
    lineJoin: "round",
  }),
});

const SelectedRouteLineLayer = ({
  selectedRouteLine,
}: SelectedRouteLineLayerProps) => {
  const { view } = useViewContext();
  const location = useLocation();

  const source = useMemo(() => {
    const vectorSource = new olVectorSource();
    return vectorSource;
  }, []);

  useEffect(() => {
    source.clear();
    if (selectedRouteLine?.location) {
      source.addFeature(
        new olFeature({ geometry: selectedRouteLine.location }),
      );

      const geomExtent = selectedRouteLine.location.getExtent();
      view.fit(geomExtent, {
        padding: [100, 100, 100, 100],
        duration: 500,
      });
    }
  }, [selectedRouteLine, source, view]);

  return (
    <Vector
      name="selected-route-line"
      source={source}
      style={selectedRouteLineStyle}
      zIndex={10001}
      visible={
        selectedRouteLine != null &&
        location.pathname.includes(MapView.ROUTE_LINE)
      }
    />
  );
};

export default SelectedRouteLineLayer;
